import * as React from 'react'

export const CircleInfoIcon = ({
  className,
  fill = 'none',
}: {
  className?: string
  fill: string
}) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 14 13"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7 13C4.84375 13 2.875 11.875 1.79688 10C0.71875 8.14844 0.71875 5.875 1.79688 4C2.875 2.14844 4.84375 1 7 1C9.13281 1 11.1016 2.14844 12.1797 4C13.2578 5.875 13.2578 8.14844 12.1797 10C11.1016 11.875 9.13281 13 7 13ZM7 4C6.67188 4 6.4375 4.25781 6.4375 4.5625V7.1875C6.4375 7.51562 6.67188 7.75 7 7.75C7.30469 7.75 7.5625 7.51562 7.5625 7.1875V4.5625C7.5625 4.25781 7.30469 4 7 4ZM6.25 9.25C6.25 9.67188 6.57812 10 7 10C7.39844 10 7.75 9.67188 7.75 9.25C7.75 8.85156 7.39844 8.5 7 8.5C6.57812 8.5 6.25 8.85156 6.25 9.25Z"
        fill="currentColor"
      />
    </svg>
  )
}
